// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__6FprL","total":"Cart_total__4ML08","actions":"Cart_actions__ewq56","button--alt":"Cart_button--alt__f3Gye","button":"Cart_button__1A2W+"};